<template>
  <div class="break-words">
    <template v-for="contentBlock in content" :key="`${id}-${contentBlock.type}`">
      <MarkdownViewer v-if="contentBlock.type === 'text'" :content="contentBlock.text" />
      <template v-else-if="isAllMessagesVisible">
        <details>
          <summary class="cursor-pointer">{{ contentBlock?.name || contentBlock.type }}</summary>
          <div class="overflow-x-auto">
            <pre v-if="contentBlock?.name === 'run_select_query'" class="whitespace-pre-wrap break-words">{{ contentBlock.arguments.query }}</pre>
            <pre v-else-if="contentBlock.type === 'tool_result'" >{{ tryJson(contentBlock.content) }}</pre>
            <pre v-else class="whitespace-pre-wrap break-words">{{ contentBlock }}</pre>
          </div>
        </details>
      </template>
    </template>
  </div>
</template>

<script setup>
import MarkdownViewer from '@/components/_common/MarkdownViewer.vue';
import { getCookie } from '@/utils/cookie';
import { computed } from 'vue';

const props = defineProps({
  content: {
    type: Array,
    required: true
  },
  id: {
    type: [String, Number],
    required: true
  }
});

const isAllMessagesVisible = computed(() => {
  return getCookie('all_messages_visible') === 'true';
});

const tryJson = (string) => {
  try {
    return JSON.parse(string);
  } catch (e) {
    return string;
  }
};
</script>
